import { render, staticRenderFns } from "./PosFeatures.vue?vue&type=template&id=e64c589e&scoped=true"
import script from "./PosFeatures.vue?vue&type=script&lang=js"
export * from "./PosFeatures.vue?vue&type=script&lang=js"
import style0 from "./PosFeatures.vue?vue&type=style&index=0&id=e64c589e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64c589e",
  null
  
)

export default component.exports